// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const PlusIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.25 16.25V22.75C16.25 23.3023 15.8023 23.75 15.25 23.75H14.75C14.1977 23.75 13.75 23.3023 13.75 22.75V16.25H7.25C6.69772 16.25 6.25 15.8023 6.25 15.25V14.75C6.25 14.1977 6.69772 13.75 7.25 13.75H13.75V7.25C13.75 6.69772 14.1977 6.25 14.75 6.25H15.25C15.8023 6.25 16.25 6.69772 16.25 7.25V13.75H22.75C23.3023 13.75 23.75 14.1977 23.75 14.75V15.25C23.75 15.8023 23.3023 16.25 22.75 16.25H16.25Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default PlusIcon;
